import React, { useState, useEffect } from 'react';
import { es } from 'date-fns/locale';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { IsDesktopHandler } from '../../../helpers';
import classes from './TextFieldWidgetDate.module.scss';
import errorMessage from '../../../common/errorMessages.json';

const TextFieldWidgetDate = (props) => {
  const {
    errors,
    success,
    labeltext,
    name,
    loading,
    disabled,
    req,
    ...others
  } = props;
  const [stateMessage, setStateMessage] = useState('');
  const [stateError, setStateError] = useState(false);

  useEffect(() => {
    if (errors && errors.message) {
      setStateMessage(errors.message);
      setStateError(true);
    } else {
      setStateMessage('');
      setStateError(false);
    }
  }, [errors]);

  let labelText = null;
  const isDesktop = IsDesktopHandler('sm');
  if (!isDesktop) {
    labelText = props.labeltext;
  } else {
    labelText = null;
  }

  return (
    <div className={classes.inputContainerStyle}>
      <div className={classes.labelDesktopStyle}>{labeltext}</div>
      {loading && <p>cargando</p>}

      <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
        <Controller
          name={name}
          control={props.control}
          defaultValue={props.defaultValue}
          rules={{
            required: errorMessage.message[name],
          }}
          render={({ field }) => (
            <DatePicker
              {...field}
              format="dd-MM-yyyy"
              label={labelText}
              disabled={disabled}
              inputFormat="dd-MM-yyyy"
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  error={stateError}
                  helperText={stateMessage}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  margin="dense"
                />
              )}
              {...others}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export default TextFieldWidgetDate;

